import {injectable} from "inversify";
import {IProgressSourceAdapter} from "@intelingu/core/stores/adapters/IProgressSourceAdapter";
import {ProgressApi, ProgressBarResponse} from "@intelingu/core/api/ProgressApi";

@injectable()
export class BackendProgressSourceAdapter implements IProgressSourceAdapter {

    constructor(
        private progressApi: ProgressApi
    ) {}

    async getProgressBar(courseId: number): Promise<ProgressBarResponse> {
        const response = await this.progressApi.getProgressBar(courseId);

        return response.data;
    }

}
